import submit from "submit-form";

export const validateCreateQuestion = (question, assert, flash) => {
  try {
    const { title, type, body } = question;

    assert(title, 400, "Title is required");

    if (type === "multiple" || type === "checkbox") {
      assert(body.options, 400, "Options are required");
      assert(body.options.length > 0, 400, "Options are required");

      const isSameLength = new Set(body.options).size === body.options.length;
      assert(isSameLength, 400, "Options must be unique");
    }

    if (type === "scale") {
      assert(body.labelLeft, 400, "Left label is required");
      assert(body.labelRight, 400, "Right label is required");
      assert(
        body?.labelLeft?.length <= 40,
        400,
        "Left label has more than 40 characters"
      );
      assert(
        body?.labelRight?.length <= 40,
        400,
        "Right label has more than 40 characters"
      );
    }

    if (type === "measurement") {
      assert(body.options, 400, "Measurement options are required");
      assert(body.options.length > 0, 400, "Measurement options are required");
    }

    return true;
  } catch (error) {
    flash("error", error.message);
    submit("/actions/refresh");
    return false;
  }
};

export const validateCreateTemplate = (template, assert, flash) => {
  try {
    const { title, questions } = template;

    assert(title, 400, "Title is required");

    assert(questions.length, 400, "Questions are required");

    assertQuestionField(questions, "bodyweight", assert);
    assertQuestionField(questions, "progress", assert);
    assertQuestionField(questions, "nutrition", assert);
    assertQuestionField(questions, "steps", assert);
    assertQuestionField(questions, "sleep", assert);
    assertQuestionField(questions, "hrv", assert);
    assertQuestionField(questions, "measurement", assert);

    return true;
  } catch (error) {
    flash("error", error.message);
    submit("/actions/refresh");
    return false;
  }
};

const assertQuestionField = (questions, field, assert) => {
  const totalFieldQuestions = questions.filter(
    (question) => question.type === field
  );

  assert(
    totalFieldQuestions.length <= 1,
    400,
    `Only one ${field} field allowed`
  );
};

export const validateCreateIndividualQuestion = (questions, assert, flash) => {
  try {
    assert(questions.length, 400, "Questions are required");

    assertQuestionField(questions, "bodyweight", assert);
    assertQuestionField(questions, "progress", assert);
    assertQuestionField(questions, "nutrition", assert);
    assertQuestionField(questions, "steps", assert);
    assertQuestionField(questions, "sleep", assert);
    assertQuestionField(questions, "hrv", assert);
    assertQuestionField(questions, "measurement", assert);

    return true;
  } catch (error) {
    flash("error", error.message);
    submit("/actions/refresh");
    return false;
  }
};

export const validateSchedule = (schedule, assert, flash) => {
  try {
    const { startDay, frequency, selectedWeeklyDays } = schedule;

    assert(frequency, 400, "Select a frequency for the schedule");
    assert(startDay, 400, "Select a day for the schedule");

    if (frequency === "daily") {
      let hasTrueValue = false;
      for (const day in selectedWeeklyDays) {
        if (selectedWeeklyDays[day].active === true) {
          hasTrueValue = true;
        }
      }

      assert(hasTrueValue, 400, "Select at least a day for the daily check in");
    }

    return true;
  } catch (error) {
    flash("error", error.message);
    submit("/actions/refresh");
    return false;
  }
};

export const isQuestionReady = (question) => {
  const { title, type, body } = question;

  let ready = false;

  if (title) ready = true;

  if (type === "multiple" || type === "checkbox") {
    const lengthReady = body.options && body.options.length > 0 ? true : false;
    const duplicateReady = new Set(body.options).size === body.options.length;

    ready = lengthReady && duplicateReady;
  }

  if (type === "scale") {
    ready = body.labelLeft && body.labelRight ? true : false;
  }

  if (type === "measurement") {
    ready = body.options && body.options.length > 0;
  }

  return ready;
};

export const isUnchanged = (question) => {
  const { title, type, body } = question;

  const titleUnchanged = title === "";
  const typeUnchanged = type === "short";
  const bodyUnchanged = body.description === "Short Answer";

  return titleUnchanged && typeUnchanged && bodyUnchanged;
};
